import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../IconButton/IconButton';
import styles from './ShareButton.scss';
import ShareModal from '../ShareModal/ShareModal';
import { useModalToggle } from '../../../hooks/useModalToggle';
import { ShareIcon } from './ShareIcon';

interface ShareButtonProps {
  disabled?: boolean;
  timelineImage?: string;
  description?: string | null;
}

const ShareButton: FunctionComponent<ShareButtonProps> = ({
  disabled = false,
  timelineImage,
  description,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { setOpen, isOpen, ref, Portal } = useModalToggle();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        className={`${styles.shareButton} ${disabled ? 'disabled' : ''}`}
        disabled={disabled}
        onClick={openModal}
        aria-label={t('timeline.shareButton')}
      >
        <ShareIcon className={styles.icon} />
      </IconButton>
      {isOpen && (
        <Portal background focusLock scrollLock>
          <ShareModal
            ref={ref}
            onClose={closeModal}
            imageUrl={timelineImage}
            description={description}
          />
        </Portal>
      )}
    </>
  );
};

export default ShareButton;
